import React from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const BackButton = () => {
  const history = useHistory();

  const handleClick = () => {
    history.push("/produtos");
  };

  return (
    <Button variant="white" className="mr-2" onClick={handleClick}>
      Voltar
    </Button>
  );
};

export default BackButton;
